import React from "react";
import Reveal from "./Reveal";

const CARE_ITEMS = [
  {
    title: "Washing",
    body:
      "Pop it in the machine on a cold, normal cycle, no fuss. It's perfectly happy washing alongside your other favourites.",
  },
  {
    title: "For that smooth, ready-to-wear finish",
    body:
      "As soon as the cycle ends, take your dress out, give it a few confident shakes, and hang it up to dry. That's it. No ironing, no steaming, just a beautifully smooth finish, ready when you are. Thanks to its quick drying fabric, it'll be back in your wardrobe rotation in no time.",
  },
  {
    title: "Love a soft, crinkled look?",
    body:
      "For a more relaxed, textured feel, let the dress dry first. Then gently twist and roll it into a ball, and leave it until your next wear. Unravel it to reveal an effortlessly chic crinkle effect.",
  },
  {
    title: "One important note",
    body: "Treat it with care, please do not tumble dry.",
  },
];

export default function Care() {
  return (
    <section
      id="care"
      className="bg-white py-24 md:py-36 border-t border-[var(--line)]"
    >
      <div className="max-w-[1200px] mx-auto px-6 sm:px-10 lg:px-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          {/* Left — heading */}
          <Reveal className="md:col-span-5 md:sticky md:top-24 md:self-start">
            <h2 className="serif text-[38px] sm:text-[52px] md:text-[60px] leading-[1.05] text-[#111] font-light">
              Care guide
              <br />
              <span className="italic">for your Magic Dress.</span>
            </h2>
            <p className="mt-6 sans text-[16px] leading-[1.85] text-[#111]/85 max-w-[440px]">
              Keeping your dress looking effortless is just as easy as wearing it.
            </p>
          </Reveal>

          {/* Right — list */}
          <div className="md:col-span-6 md:col-start-7">
            <div className="divide-y divide-[var(--line)]">
              {CARE_ITEMS.map((item, i) => (
                <Reveal
                  key={item.title}
                  delay={i * 80}
                  className="py-8 first:pt-0 last:pb-0"
                  data-testid={`care-item-${i}`}
                >
                  <div className="flex items-baseline gap-5">
                    <span className="serif italic text-[17px] text-[#111]/50 shrink-0">
                      0{i + 1}
                    </span>
                    <div>
                      <h3 className="serif text-[22px] sm:text-[24px] text-[#111] leading-[1.25]">
                        {item.title}
                      </h3>
                      <p className="mt-3 sans text-[15px] leading-[1.85] text-[#111]/85">
                        {item.body}
                      </p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
